import {AbProgressBarController} from "@/scripts/components/ab-progress-bar/abProgressBar.controller";
import "./abProgressBar.style.scss";
import {NAMES} from "@/scripts/components/ab-progress-bar/constants/abProgressBar.constants";

export function defineAbProgressBarElement() {

  const TAG_NAME = NAMES.TAG_NAME;
  if (customElements.get(TAG_NAME)) return;

  class AbProgressBarElement extends HTMLElement {

    constructor() {
      super();
      this.bindEvents();
    }

    #ctrl?: AbProgressBarController;
    #initialized: boolean = false;
    #observer?: IntersectionObserver;

    static get observedAttributes(): string[] {
      return ["value", "bg-color", "text-color", "show-perc"];
    }

    connectedCallback() {
      if(this.#initialized) return;
      this.#initialized = true;
      this.#ctrl = new AbProgressBarController(this);
      this.#ctrl.syncFromAttributes();
      this.#ctrl.render();
    }

    disconnectedCallback() {
      if(!this.#observer) return;
      this.#observer.disconnect();
      this.#observer = undefined;
    }

    attributeChangedCallback() {
      if (!this.isConnected || !this.#initialized) return;
      this.#ctrl.syncFromAttributes();
      this.#ctrl.render();
    }

    private bindEvents() {
      this.#observer = new IntersectionObserver(([entry]) => {
        if (entry.intersectionRatio > 0) {
          this.#ctrl.animate();
        }
      }, { threshold: 0.5 });
      this.#observer.observe(this);
    }

}

  customElements.define(TAG_NAME, AbProgressBarElement);
}